export default function sortByName(a, b) {
    return a.text >= b.text ? 1 : -1;
}
